import React from "react";

const Sudoku: React.FC = () => {
  return (
    <main className="px-6 py-10">
      <h1 className="text-3xl font-bold text-white mb-4">Hangman</h1>
      <p className="text-white">filler page</p>
    </main>
  );
};

export default Sudoku;
